module.exports = __webpack_public_path__ + "img/ok.2e0e7368.png";